import {useWordScores} from "data/access/survey-question-pages/word-scores";
import LoadingSurvey from "components/Survey/LoadingSurvey";
import React from "react";
import {assertNoError} from "helpers/asserts";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";


export const HowToUseBestWordsChartTitle = () => {
  return <span className={"font-bold text-black text-xl"}>How to use this chart</span>;
}

export function BestWordsChartComponent() {
  const [wordScores, wordScoresLoading, wordScoresError] = useWordScores();

  if (wordScoresLoading) {
    return <LoadingSurvey/>;
  }
  assertNoError(wordScoresError);
  if (isNullOrUndefined(wordScores)) {
    return <></>;
  }

  const greenScores = wordScores.filter(wordScore => wordScore.score > 0);
  const maxGreenScore = Math.max(...greenScores.map(wordScore => wordScore.score));
  const redScores = wordScores.filter(wordScore => wordScore.score < 0);
  const minRedScore = Math.min(...redScores.map(wordScore => wordScore.score));

  return <div className={"my-8 flex flex-col w-full border border-neutral-100 rounded-lg"}>
    <div className={"flex flex-col bg-bc-green/10"}>
      <div className={"flex flex-row"}>
        <div className={"w-1/3 py-2 ml-4"}>
          <span className={"font-bold text-xl text-black"}>best words</span>
        </div>
        <div className={"w-0 border-l border-neutral-200"}></div>
        <div className={"w-2/3 py-2"}>
          {greenScores.length === 0 && <div className={"ml-4"}>
              <span className={"text-neutral-500 italic"}>No words are recommended for inclusion</span>
          </div>}
        </div>
      </div>
      {greenScores.map((wordScore, index) => (<div className={"flex flex-row"} key={index}>
        <div className={"w-1/3 py-2 ml-4"}>
          <span className={"text-neutral-500"}>{wordScore.value}</span>
        </div>
        <div className={"w-0 border-l border-neutral-200"}></div>
        <div className={"w-2/3 py-1 pr-4"}>
          <div
              className={"bg-bc-green h-full"}
              style={{
                width: `${wordScore.score / maxGreenScore * 100}%`
              }}
          ></div>
        </div>
      </div>))}
      <div className={"flex flex-row"}>
        <div className={"w-1/3 py-2 ml-4"}>
        </div>
        <div className={"w-0 border-l border-neutral-200"}></div>
        <div className={"w-2/3 py-2"}></div>
      </div>
    </div>
    <div className={"flex flex-col bg-bc-red/10"}>
      <div className={"flex flex-row"}>
        <div className={"w-1/3 py-2 ml-4"}>
          <span className={"font-bold text-xl"}>words to avoid</span>
        </div>
        <div className={"w-0 border-l border-neutral-200"}></div>
        <div className={"w-2/3 py-2"}>
          {redScores.length === 0 && <div className={"ml-4"}>
              <span className={"text-neutral-500 italic"}>No words are recommended for exclusion</span>
          </div>}
        </div>
      </div>
      {redScores.map((wordScore, index) => (<div className={"flex flex-row"} key={index}>
        <div className={"w-1/6 py-2 ml-4"}>
          <span className={"text-neutral-500"}>{wordScore.value}</span>
        </div>
        <div className={"flex flex-row-reverse w-1/6 py-1"}>
          <div
              className={"bg-bc-red h-full"}
              style={{
                width: `${wordScore.score / minRedScore * 100}%`
              }}
          ></div>
        </div>
        <div className={"w-0 border-l border-neutral-200"}></div>
        <div className={"w-2/3 py-2 pr-4"}>
        </div>
      </div>))}
      <div className={"flex flex-row"}>
        <div className={"w-1/6 py-2 ml-4"}></div>
        <div className={"w-1/6 py-2"}></div>
        <div className={"w-0 border-l border-neutral-200"}></div>
        <div className={"w-2/3 py-2"}></div>
      </div>
    </div>
  </div>

}
